import { InjectionToken } from '@angular/core';

/** Full-page navigation to an external URL; injectable so it can be replaced in tests. */
export const BROWSER_NAVIGATE = new InjectionToken<(url: string) => void>('BROWSER_NAVIGATE', {
  providedIn: 'root',
  factory: () => (url: string) => window.location.assign(url),
});
